import { Injectable } from "@angular/core";
import { Introducer } from "./introducer.model";

@Injectable()
export class PerspectiveService {
    private _activeIntroducer: Introducer;

    constructor() {
        this._activeIntroducer = JSON.parse(localStorage.getItem("active_introducer"));
    }

    get activeIntroducer(): Introducer {
        //if (!this.activeIntroducer) {
        //    this.router.navigate(["/perspective"]);
        //}

        return this._activeIntroducer;
    }

    set activeIntroducer(value: Introducer) {
        // save to localStorage incase user refreshes the browser
        localStorage.setItem("active_introducer", JSON.stringify(value))
        this._activeIntroducer = value;
    }

    getActiveIntroducerID(): string {
        return this._activeIntroducer
            ? this._activeIntroducer.entityID.toString()
            : null;
    }

    removeActiveIntroducer(): void {
        localStorage.removeItem("active_introducer");
        this._activeIntroducer = null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/perspective/perspective.service.ts